import * as DateF from 'date-fns'
import styled, { css } from 'styled-components'

import { DurationFormatter, Tooltip } from '@blade/ui-kit'
import { Network } from '@root/entities/network/model'
import { type Pair, usePairAgeFormatted } from '@root/entities/pair'
import { DATE_FORMAT, PlatformUtil } from '@root/shared'

type Props = {
  pair: Pair.PairMinimal
}

export const PairInformationAgeTime: React.FC<Props> = ({ pair }) => {
  const { formatted: pairAge, largestDurationUnit } = usePairAgeFormatted(
    pair.createdAt,
  )

  const createdAt = pair.createdAt
  if (pairAge) {
    const handleExploreOpen = (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation()
      const explorerLink = Network.makeExplorerContractLink(
        pair.network,
        pair.quote.address,
      )

      PlatformUtil.openLink(explorerLink)
    }

    return (
      <Tooltip
        content={
          createdAt
            ? DateF.format(createdAt, DATE_FORMAT.HH_mm__dd_MM_yy)
            : undefined
        }
      >
        <Root
          onClick={handleExploreOpen}
          $width={
            largestDurationUnit === DurationFormatter.Unit.Seconds
              ? '3ch'
              : undefined
          }
        >
          {pairAge}
        </Root>
      </Tooltip>
    )
  }
}

const Root = styled.div<{ $width?: string }>`
  ${({ $width }) =>
    $width
      ? css`
          width: ${$width};
        `
      : ''}

  font-weight: 400;
  font-size: 11px;
  line-height: normal;

  font-style: normal;
  display: grid;
  align-items: center;
`
